import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'

import rgba from 'lib/rgba'
import { createUseStyles } from 'react-jss'
import { transitionFluid } from 'styles/mixins'

const useStyles = createUseStyles(({ colors, zIndexes }) => ({
  menu: {
    ...transitionFluid(),
    background: colors.light,
    borderRadius: [12, 0, 12, 12],
    boxShadow: `0px 10px 30px ${rgba(colors.primary, 0.12)}`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    paddingTop: 10,
    position: 'absolute',
    whiteSpace: 'nowrap',
    zIndex: zIndexes.popup,

    top: '100%',
    right: 0,

    maxHeight: 320,
    overflowY: 'auto'
  },

  open: {
    opacity: 1,
    visibility: 'visible',
    pointerEvents: 'auto'
  },
  close: {
    opacity: 0,
    visibility: 'hidden',
    pointerEvents: 'none'
  },

  flipY: {
    top: 'auto',
    bottom: '100%'
  },
  alignLeft: {
    right: 'auto',
    left: 0
  }
}))

function Menu({ children, className, visible }) {
  const classes = useStyles()
  const menuRef = useRef(null)
  const [flipY, setFlipY] = useState(false)
  const [alignLeft, setAlignLeft] = useState(false)

  const recompute = () => {
    const el = menuRef.current
    if (!el || !visible) return

    setFlipY(false)
    setAlignLeft(false)

    requestAnimationFrame(() => {
      const rect = el.getBoundingClientRect()
      const vw = window.innerWidth
      const vh = window.innerHeight
      const pad = 8

      if (rect.bottom > vh - pad) setFlipY(true)

      if (rect.right > vw - pad) setAlignLeft(true)
    })
  }

  useLayoutEffect(() => {
    recompute()
  }, [visible, children])
  useEffect(() => {
    if (!visible) return
    const onResize = () => recompute()
    window.addEventListener('resize', onResize)
    window.addEventListener('scroll', onResize, true)
    return () => {
      window.removeEventListener('resize', onResize)
      window.removeEventListener('scroll', onResize, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  return (
    <div
      ref={menuRef}
      className={classNames(
        classes.menu,
        className,
        { [classes.open]: visible, [classes.close]: !visible },
        { [classes.flipY]: flipY, [classes.alignLeft]: alignLeft }
      )}
      role="menu"
    >
      {children}
    </div>
  )
}

Menu.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool.isRequired
}

Menu.defaultProps = {
  className: null
}

export default Menu
